import React from 'react';
import FeedbackButton from './FeedbackButton';
import InterestUri from '../../../Enum/InterestUri';
import { Link } from 'react-router-dom';
import { MenuItem } from '../../../Interface/MenuItem';
import { Nav } from 'react-bootstrap';
import { RouteComponentProps, withRouter } from 'react-router';
import useGetEngine from '../../../Hook/UseGetEngine';

const INTEREST_ITEMS: MenuItem[] = [
    {
        uri: InterestUri.FixedPeriod,
        label: 'o.b.v. Rentevast periode',
    },
    {
        uri: InterestUri.MarketValue,
        label: 'o.b.v. Marktwaarde',
    },
    {
        uri: InterestUri.BridgingLoan,
        label: 'Overbruggingskrediet',
    },
    {
        uri: InterestUri.Product,
        label: 'Per product',
    },
];

const PROPERTY_ITEMS: MenuItem[] = [
    {
        uri: InterestUri.PropertiesPerLabel,
        label: 'Per product',
    },
    {
        uri: InterestUri.PropertiesPerProperty,
        label: 'o.b.v. Voorwaarden',
    },
];

const CHANGE_ITEMS: MenuItem[] = [
    {
        uri: InterestUri.InterestNews,
        label: 'Rente per product',
    },
    {
        uri: InterestUri.PropertiesNews,
        label: 'Voorwaarden per product',
    },
];

type Props = RouteComponentProps<{ section: string }>;

const Side: React.FC<Props> = (props: Props) => {
    const { section } = props.match.params;
    const { isProductPropertiesOnly } = useGetEngine();

    return (
        <>
            <Nav className="sidebar" activeKey={section}>
                <span className="navbar-brand context-interest" />
                {!isProductPropertiesOnly() && (
                    <>
                        <h4>Hypotheekrentes</h4>
                        <div className="sidebar__nav-group">
                            {INTEREST_ITEMS.map(interestItem => (
                                <Nav.Item key={interestItem.uri}>
                                    <Nav.Link as={Link} to={`/rente/${interestItem.uri}`} eventKey={interestItem.uri}>
                                        {interestItem.label}
                                    </Nav.Link>
                                </Nav.Item>
                            ))}
                        </div>
                    </>
                )}
                <h4>Hypotheekvoorwaarden</h4>
                <div className="sidebar__nav-group">
                    {PROPERTY_ITEMS.map(propertiesItem => (
                        <Nav.Item key={propertiesItem.uri}>
                            <Nav.Link as={Link} to={`/rente/${propertiesItem.uri}`} eventKey={propertiesItem.uri}>
                                {propertiesItem.label}
                            </Nav.Link>
                        </Nav.Item>
                    ))}
                </div>
                <h4>Updates</h4>
                <div className="sidebar__nav-group">
                    {CHANGE_ITEMS.map(changeItem => (
                        <Nav.Item key={changeItem.uri}>
                            <Nav.Link as={Link} to={`/rente/${changeItem.uri}`} eventKey={changeItem.uri}>
                                {changeItem.label}
                            </Nav.Link>
                        </Nav.Item>
                    ))}
                </div>
                <FeedbackButton />
            </Nav>
        </>
    );
};

const Sidebar = withRouter(Side);

export default Sidebar;
